import defaultLogo from 'url:../../img/default-logo-webapp.png';
import { initFieldUploadImage } from '../utils/uploadImageField.js';
import lang from '../../lang/prop-en-module.js';

const logo = initFieldUploadImage({
  fieldUploadImage: '#logo-field',
  rootPath: 'webapp-etc',
});

const background = initFieldUploadImage({
  fieldUploadImage: '#background-field',
  rootPath: 'webapp-etc',
});

const bannerTop = initFieldUploadImage({
  fieldUploadImage: '#banner-top-field',
  rootPath: 'webapp-etc',
});

const bannerBottom = initFieldUploadImage({
  fieldUploadImage: '#banner-bottom-field',
  rootPath: 'webapp-etc',
});

export function initWebappControls() {
  logo.initListeners();
  background.initListeners();
  bannerTop.initListeners();
  bannerBottom.initListeners();
  initSMSListeners();
}

export function setDefaultLogoSrc(src = defaultLogo) {
  logo.setDefaultSrc(src);
}

export function setDefaultBackgroundSrc(src) {
  background.setDefaultSrc(src);
}

export function setDefaultBannerTopSrc(src) {
  bannerTop.setDefaultSrc(src);
}

export function setDefaultBannerBottomSrc(src) {
  bannerBottom.setDefaultSrc(src);
}

function initSMSListeners() {
  $('#webappSMS .image-upload-field__checkbox').on('click', () => {
    enableSMSForm(isEnabledSMS());
  });
}

export function enableSMSForm(isEnabled) {
  $('#webappSMSText').prop('disabled', !isEnabled);
}

export function isEnabledSMS() {
  return $('#webappSMS .image-upload-field__checkbox').is(':checked');
}

export function isValidSMSText() {
  if (isEnabledSMS()) {
    const text = getSMSText();
    if (text.length === 0) {
      alert(lang.webapp.smsText.required);
      return;
    }
    if (!text.includes('{userName}') && !text.includes('{url}')) {
      alert(lang.webapp.smsText.shouldIncludeUserAndLink);
      return;
    }
    if (!text.includes('{userName}')) {
      alert(lang.webapp.smsText.shouldIncludeUser);
      return;
    }
    if (!text.includes('{url}')) {
      alert(lang.webapp.smsText.shouldIncludeUrl);
      return;
    }
  }
  return true;
}

function getSMSText() {
  return $('#webappSMSText').val().trim();
}
